import { AxiosResponse } from 'axios'
import { DataService } from '../../utils/dataService'

export const GET_CITIES = 'GET_CITIES'


export const handleGetCities = (path: string, country: string = 'CO') => (dispatch: any) => {
  const _dataService = new DataService()

  
  const data = {
    //url: window.location.href,
    url: path,
    filter:{
      country,
      origin: 'epayco'
    }
  }

  _dataService
    .post('/cities', data)
    .then((res: AxiosResponse) => {
      if (res.status === 200 && res.data.success === true) {
        dispatch({
          type: GET_CITIES,
          payload: {
            cities: res.data.data
          }
        })
      }
    })
}

